import { useState } from "react";
import { sendAdminLoginEmail } from "../../services";
import { DashboardFrame } from "../../components/Dashboard";
import { showError } from "../../helpers";
import { Button } from "@jobber/components/Button";
import { Content } from "@jobber/components/Content";
import { Form } from "@jobber/components/Form";
import { Heading } from "@jobber/components/Heading";
import { InputText } from "@jobber/components/InputText";
import { Text } from "@jobber/components/Text";
import { useFormState } from "@jobber/hooks";

function Login() {
    const [{ isDirty, isValid }, setFormState] = useFormState();
    const [adminEmail, setAdminEmail] = useState("");

    const [isSendingLoginEmail, setIsSendingLoginEmail] = useState(false);
    const [hasSentLoginEmail, setHasSentLoginEmail] = useState(false);
    const [buttonText, setButtonText] = useState("Send login email");

    function sendLoginEmail(e: React.MouseEvent) {
        e.preventDefault();
        setIsSendingLoginEmail(true);
        setButtonText("Sending email...");
        (async () => {
            try {
                await sendAdminLoginEmail(adminEmail);
                setHasSentLoginEmail(true);
                setIsSendingLoginEmail(false);
                setButtonText("Email sent, please check your inbox");
            } catch(e: any) {
                setIsSendingLoginEmail(false);
                setButtonText("Resend email");
                showError("Error sending login email: " + e.message);
            }
        })();
    }

    return (
        <DashboardFrame>
            <Content type={"div"} spacing={"base"}>
                <Heading level={1}>
                    Login to Dashboard
                </Heading>
                <Text size={"large"}>
                    Please enter your administrator email address to log in.
                </Text>
                <Text size={"large"}>
                    You'll receive a magic link in your inbox that you can click to access the dashboard.
                </Text>

                <Form
                    onStateChange={setFormState}
                >
                    <div
                        style={{
                            maxWidth: "500px",
                        }}
                    >
                        <InputText
                            name={"adminEmail"}
                            placeholder={"Administrator email"}
                            keyboard={"numeric"}
                            validations={{
                                required: {
                                    value: true,
                                    message: "Email address is required.",
                                },
                                pattern: {
                                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                    message: "Please enter a valid email address.",
                                },
                            }}
                            onChange={(adminEmail) => setAdminEmail(adminEmail as string)}
                        />
                    </div>
                </Form>

                <Button
                    label={buttonText}
                    type="primary"
                    disabled={!isValid || hasSentLoginEmail}
                    loading={isSendingLoginEmail}
                    onClick={sendLoginEmail}
                />

            </Content>
        </DashboardFrame>
    );
}

export default Login;
